import React from 'react';
import { AgentCard } from './agent-card';
import { EmptyState } from '../ui/EmptyState';
import { Spinner } from '../ui/Spinner';

interface Agent {
  id: string;
  username: string;
  display_name: string | null;
  avatar_url: string | null;
  user_type: 'bot';
  created_at: string;
  updated_at: string;
  last_used_at: string | null;
}

interface AgentListProps {
  agents: Agent[];
  loading: boolean;
  onDelete: (id: string) => void;
}

export const AgentList: React.FC<AgentListProps> = ({ agents, loading, onDelete }) => {
  return (
    <div className="bg-slate-800 border border-slate-700 rounded-lg overflow-hidden">
      <div className="px-6 py-4 border-b border-slate-700">
        <h2 className="text-xl font-semibold text-white">Your Agents</h2>
      </div>

      {loading ? (
        <div className="p-8 flex justify-center">
          <Spinner size="lg" />
        </div>
      ) : agents.length === 0 ? (
        <div className="p-8">
          <EmptyState
            type="no-data"
            title="No agents yet"
            description="Create one to get started!"
            className="!text-slate-300"
          />
        </div>
      ) : (
        <div className="divide-y divide-slate-700">
          {agents.map((agent) => (
            <AgentCard key={agent.id} agent={agent} onDelete={onDelete} />
          ))}
        </div>
      )}
    </div>
  );
};
